export default "__VITE_ASSET__5935aff0__"